/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactListRequest {
    getFixupPrototypeFunction() { return ArtifactListRequest.fixupPrototype; }

    static newInstance(model: Partial<ArtifactListRequest>): ArtifactListRequest {
        let obj = Object.assign(new ArtifactListRequest(), model);
        ArtifactListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactListRequest>): ArtifactListRequest {
        if (!model) return null;
        return ArtifactListRequest.newInstance(<ArtifactListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactListRequest) {
        if (!obj) return;

        models.ArtifactListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactListRequest): boolean {
        Object.setPrototypeOf(obj, ArtifactListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ArtifactFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ArtifactSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ArtifactSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.ArtifactFilter;

}
